{
  "verified": "2026-10-16",
  "sources": ["https://commons.wikimedia.org", "https://images.nasa.gov", "https://lroc.im-ldi.com"],
  "images": [
    {
      "id": "mission-chandrayaan-2",
      "target": "mission:chandrayaan-2",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/ef/GSLV_Mk_III_M1%2C_Chandrayaan-2_-_Vikram_lander_mounted_on_top_of_orbiter.jpg",
      "credit": "Indian Space Research Organisation (ISRO)",
      "licence": "godl-india",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:GSLV_Mk_III_M1,_Chandrayaan-2_-_Vikram_lander_mounted_on_top_of_orbiter.jpg"
      ]
    },
    {
      "id": "mission-danuri",
      "target": "mission:danuri",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e9/Kplo_rendered_image.png",
      "credit": "Ministry of Science and ICT (Korea)",
      "licence": "kogl-1",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Kplo_rendered_image.png"]
    },
    {
      "id": "mission-capstone",
      "target": "mission:capstone",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/d7/CAPSTONE_facing_the_Sun_%28ACD22-0003-004%29.jpg",
      "credit": "NASA/Daniel Rutter",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:CAPSTONE_facing_the_Sun_(ACD22-0003-004).jpg"]
    },
    {
      "id": "mission-mars-express",
      "target": "mission:mars-express",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/a/af/Mars_Express_ESA392355.jpg",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Mars_Express_ESA392355.jpg"]
    },
    {
      "id": "mission-exomars-tgo",
      "target": "mission:exomars-tgo",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/a/ab/The_Red_Planet_welcomes_ExoMars_ESA16185426.png",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:The_Red_Planet_welcomes_ExoMars_ESA16185426.png"]
    },
    {
      "id": "mission-emm-hope",
      "target": "mission:emm-hope",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/b2/Mars_Clouds_-_Orbit_47_-_Hope_Mission_%2851584717024%29.png",
      "credit": "Andrea Luck (EMM data)",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Mars_Clouds_-_Orbit_47_-_Hope_Mission_(51584717024).png"
      ]
    },
    {
      "id": "mission-tianwen-1",
      "target": "mission:tianwen-1",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/4f/Tianwen-1_in_Mars_orbit.jpg",
      "credit": "Ling Xin/CNSA",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Tianwen-1_in_Mars_orbit.jpg"]
    },
    {
      "id": "mission-mom",
      "target": "mission:mom",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Mars_Orbiter_Mission_-_India_-_ArtistsConcept.jpg",
      "credit": "Nesnad",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Mars_Orbiter_Mission_-_India_-_ArtistsConcept.jpg"]
    },
    {
      "id": "mission-mmx",
      "target": "mission:mmx",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e7/Mmxspacecraft_0.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Mmxspacecraft_0.jpg"]
    },
    {
      "id": "mission-solar-orbiter",
      "target": "mission:solar-orbiter",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/9e/Solar_Orbiter_STM_%2816738451658%29.jpg",
      "credit": "UCL Mathematical and Physical Sciences",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Solar_Orbiter_STM_(16738451658).jpg"]
    },
    {
      "id": "mission-psyche",
      "target": "mission:psyche",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e6/Psyche_Prelaunch_Spacecraft_Processing_%28KSC-20230626-PH-FMX01_0015%29.jpg",
      "credit": "NASA/Frank Michaux",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Psyche_Prelaunch_Spacecraft_Processing_(KSC-20230626-PH-FMX01_0015).jpg"
      ]
    },
    {
      "id": "mission-lucy",
      "target": "mission:lucy",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/0f/Lucy-PatroclusMenoetius-art.png",
      "credit": "NASA’s Goddard Space Flight Center/Conceptual Image Lab/Adriana Gutierrez",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Lucy-PatroclusMenoetius-art.png"]
    },
    {
      "id": "mission-hera",
      "target": "mission:hera",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/50/Hera_in_orbit.jpg",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Hera_in_orbit.jpg"]
    },
    {
      "id": "mission-tianwen-2",
      "target": "mission:tianwen-2",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/dd/Rendering_of_Tianwen_2_asteroid_mission_02.png",
      "credit": "China News Service",
      "licence": "cc-by-3.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Rendering_of_Tianwen_2_asteroid_mission_02.png"]
    },
    {
      "id": "mission-hayabusa2",
      "target": "mission:hayabusa2",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/28/Hayabusa2_approaching_asteroid.jpg",
      "credit": "DLR",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Hayabusa2_approaching_asteroid.jpg"]
    },
    {
      "id": "mission-aditya-l1",
      "target": "mission:aditya-l1",
      "kind": "launch",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/29/PSLV-XL_%28C57%29_Aditya-L1_ISRO.jpg",
      "credit": "Indian Space Research Organisation (ISRO)",
      "licence": "cc-by-3.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:PSLV-XL_(C57)_Aditya-L1_ISRO.jpg"]
    },
    {
      "id": "mission-gaia",
      "target": "mission:gaia",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/fd/Gaia_observes_the_Milky_Way_ESA24305955.jpeg",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Gaia_observes_the_Milky_Way_ESA24305955.jpeg"]
    },
    {
      "id": "mission-euclid",
      "target": "mission:euclid",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/68/Euclid_looking_into_the_Universe_ESA24697255.jpeg",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Euclid_looking_into_the_Universe_ESA24697255.jpeg"]
    },
    {
      "id": "mission-dart",
      "target": "mission:dart",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f5/DART_spacecraft_model_2.png",
      "credit": "NASA/Johns Hopkins APL",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:DART_spacecraft_model_2.png"]
    },
    {
      "id": "mission-imap",
      "target": "mission:imap",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/57/NASA%27s_IMAP_Spacecraft_Lift_to_Work_Stand_and_Unbagging_%28KSC-20250529-PH-AJN01_0222%29.jpg",
      "credit": "NASA/Amber Jean Notvest",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:NASA%27s_IMAP_Spacecraft_Lift_to_Work_Stand_and_Unbagging_(KSC-20250529-PH-AJN01_0222).jpg"
      ]
    },
    {
      "id": "mission-carruthers",
      "target": "mission:carruthers",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/8/8a/Carruthers_Geocorona_Observatory_Images_%28SVS14830_-_Carruthers_Wide_0001-Edited%29.jpg",
      "credit": "NASA's Scientific Visualization Studio",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Carruthers_Geocorona_Observatory_Images_(SVS14830_-_Carruthers_Wide_0001-Edited).jpg"
      ]
    },
    {
      "id": "mission-solar-1",
      "target": "mission:solar-1",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/25/SWFO-L1.jpg",
      "credit": "NOAA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:SWFO-L1.jpg"]
    },
    {
      "id": "mission-neo-surveyor",
      "target": "mission:neo-surveyor",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/77/Illustration_of_NEO_Surveyor_against_an_infrared_starfield_%28PIA25253%29.jpg",
      "credit": "NASA/JPL-Caltech/University of Arizona",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Illustration_of_NEO_Surveyor_against_an_infrared_starfield_(PIA25253).jpg"
      ]
    },
    {
      "id": "mission-comet-interceptor",
      "target": "mission:comet-interceptor",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/41/Comet_Interceptor.png",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Comet_Interceptor.png"]
    },
    {
      "id": "site-apollo-11",
      "target": "site:apollo-11",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/as11-40-5927/as11-40-5927~orig.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://www.nasa.gov/image-detail/amf-as11-40-5927/"]
    },
    {
      "id": "site-apollo-12",
      "target": "site:apollo-12",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/as12-47-6988/as12-47-6988~orig.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://www.nasa.gov/image-detail/amf-as12-47-6988/"]
    },
    {
      "id": "site-apollo-14",
      "target": "site:apollo-14",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/as14-66-09277/as14-66-09277~orig.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://www.nasa.gov/image-detail/amf-as14-66-09277/"]
    },
    {
      "id": "site-apollo-15",
      "target": "site:apollo-15",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/62/AS15-88-11866_-_Apollo_15_flag%2C_rover%2C_LM%2C_Irwin_-_restoration1.jpg",
      "credit": "NASA, restored by Bammesk",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:AS15-88-11866_-_Apollo_15_flag,_rover,_LM,_Irwin_-_restoration1.jpg"
      ]
    },
    {
      "id": "site-apollo-16",
      "target": "site:apollo-16",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/b3/John_W._Young_on_the_Moon.jpg",
      "credit": "NASA/Charlie Duke",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:John_W._Young_on_the_Moon.jpg"]
    },
    {
      "id": "site-apollo-17",
      "target": "site:apollo-17",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/a/ac/Eugene_Cernan_at_the_LM%2C_Apollo_17%2C_AS17-134-20378.jpg",
      "credit": "NASA/Harrison Schmitt",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Eugene_Cernan_at_the_LM,_Apollo_17,_AS17-134-20378.jpg"
      ]
    },
    {
      "id": "site-luna-9",
      "target": "site:luna-9",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e7/Luna_9_Musee_du_Bourget_P1010505.JPG",
      "credit": "Pline",
      "licence": "cc-by-sa-3.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Luna_9_Musee_du_Bourget_P1010505.JPG"]
    },
    {
      "id": "site-luna-13",
      "target": "site:luna-13",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/de/Luna13_lander_vsm.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Luna13_lander_vsm.jpg"]
    },
    {
      "id": "site-luna-16",
      "target": "site:luna-16",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/a/ab/Luna_16_Space_Probe_01.jpg",
      "credit": "Stolbovsky",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Luna_16_Space_Probe_01.jpg"]
    },
    {
      "id": "site-luna-17",
      "target": "site:luna-17",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/33/Luna_and_Lunokhod.png",
      "credit": "Post of the Soviet Union",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Luna_and_Lunokhod.png"]
    },
    {
      "id": "site-lunokhod-1",
      "target": "site:lunokhod-1",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/76/Lunokhod_1_moon_rover_%28MMA_2011%29_%282%29.JPG",
      "credit": "Armael",
      "licence": "cc0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Lunokhod_1_moon_rover_(MMA_2011)_(2).JPG"]
    },
    {
      "id": "site-luna-20",
      "target": "site:luna-20",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/66/Luna_16_20_24_2_render.jpg",
      "credit": "NASA/NSSDCA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Luna_16_20_24_2_render.jpg"]
    },
    {
      "id": "site-luna-21",
      "target": "site:luna-21",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Moon_walker_-_Lunokhod_2.jpg",
      "credit": "JukoFF",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Moon_walker_-_Lunokhod_2.jpg"]
    },
    {
      "id": "site-lunokhod-2",
      "target": "site:lunokhod-2",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/fd/Lunokhod_2_in_Kaluga_02.jpg",
      "credit": "Stolbovsky",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Lunokhod_2_in_Kaluga_02.jpg"]
    },
    {
      "id": "site-luna-23",
      "target": "site:luna-23",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/b8/Mare_Crisium-_Failure_then_Success_%28LROC461_-_luna23_24_regional%29.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Mare_Crisium-_Failure_then_Success_(LROC461_-_luna23_24_regional).png"
      ]
    },
    {
      "id": "site-luna-24",
      "target": "site:luna-24",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/b8/Mare_Crisium-_Failure_then_Success_%28LROC461_-_luna23_24_regional%29.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Mare_Crisium-_Failure_then_Success_(LROC461_-_luna23_24_regional).png"
      ]
    },
    {
      "id": "site-surveyor-1",
      "target": "site:surveyor-1",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/36/Surveyor_1_shadow_lunarsurface.jpg",
      "credit": "NASA/JPL",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Surveyor_1_shadow_lunarsurface.jpg"]
    },
    {
      "id": "site-surveyor-3",
      "target": "site:surveyor-3",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/59/ARTIST_CONCEPT_-_SURVEYOR_III_-_OCEAN_OF_STORM_%28S69-55553%29.jpg",
      "credit": "NASA Johnson Space Center",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:ARTIST_CONCEPT_-_SURVEYOR_III_-_OCEAN_OF_STORM_(S69-55553).jpg"
      ]
    },
    {
      "id": "site-surveyor-5",
      "target": "site:surveyor-5",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/7f/Lunar_Lander%2C_Surveyor_-_DPLA_-_d6accc3d89e8efa6f2e88962941bf43a_%28page_5%29.jpg",
      "credit": "Hughes Aircraft Co",
      "licence": "cc0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Lunar_Lander,_Surveyor_-_DPLA_-_d6accc3d89e8efa6f2e88962941bf43a_(page_5).jpg"
      ]
    },
    {
      "id": "site-surveyor-6",
      "target": "site:surveyor-6",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/14/Lunar_Lander%2C_Surveyor_-_DPLA_-_d6accc3d89e8efa6f2e88962941bf43a_%28page_6%29.jpg",
      "credit": "Hughes Aircraft Co",
      "licence": "cc0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Lunar_Lander,_Surveyor_-_DPLA_-_d6accc3d89e8efa6f2e88962941bf43a_(page_6).jpg"
      ]
    },
    {
      "id": "site-surveyor-7",
      "target": "site:surveyor-7",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/d5/Lunar_Lander%2C_Surveyor_-_DPLA_-_d6accc3d89e8efa6f2e88962941bf43a_%28page_7%29.jpg",
      "credit": "Hughes Aircraft Co",
      "licence": "cc0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Lunar_Lander,_Surveyor_-_DPLA_-_d6accc3d89e8efa6f2e88962941bf43a_(page_7).jpg"
      ]
    },
    {
      "id": "site-change-3",
      "target": "site:change-3",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/08/Chang%27e_3_Lander_and_Rover_From_Above_%28LROC637_-_landerview_lroc_crop%29.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Chang%27e_3_Lander_and_Rover_From_Above_(LROC637_-_landerview_lroc_crop).png"
      ]
    },
    {
      "id": "site-yutu",
      "target": "site:yutu",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/55/Yutu_rover.jpg",
      "credit": "Institute of High Energy Physics, Chinese Academy of Sciences",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Yutu_rover.jpg"]
    },
    {
      "id": "site-change-4",
      "target": "site:change-4",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/41/ChangE-4_-_PCAM_%2851216550288%29.png",
      "credit": "CNSA/Siyu Zhang/Kevin M. Gill",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:ChangE-4_-_PCAM_(51216550288).png"]
    },
    {
      "id": "site-change-5",
      "target": "site:change-5",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/5e/Chang%27e_5_docking_%284%29.png",
      "credit": "China News Service",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Chang%27e_5_docking_(4).png"]
    },
    {
      "id": "site-change-6",
      "target": "site:change-6",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/39/First_Look-_Chang%27e_6_%28LROC1374%29.jpg",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:First_Look-_Chang%27e_6_(LROC1374).jpg"]
    },
    {
      "id": "site-chandrayaan-3-vikram",
      "target": "site:chandrayaan-3-vikram",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/db/Chandrayaan_3_Vikram_lander_stereo_%2853167467822%29_crop.png",
      "credit": "ISRO/Simeon Schmauß",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Chandrayaan_3_Vikram_lander_stereo_(53167467822)_crop.png"
      ]
    },
    {
      "id": "site-slim",
      "target": "site:slim",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/5b/SLIM_at_Expo2025_02.jpg",
      "credit": "Artem.G",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:SLIM_at_Expo2025_02.jpg"]
    },
    {
      "id": "site-im-1-odysseus",
      "target": "site:im-1-odysseus",
      "kind": "orbital",
      "file": "https://lroc.im-ldi.com/ckeditor_assets/pictures/1425/content_Nova_C_1100x1100_crop.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://lroc.im-ldi.com/images/1360"]
    },
    {
      "id": "site-im-2-athena",
      "target": "site:im-2-athena",
      "kind": "orbital",
      "file": "https://lroc.im-ldi.com/ckeditor_assets/pictures/1494/content_M1495922531_LRmos.warp.str01_str02.3xdecimated.1300p.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://lroc.im-ldi.com/images/1408"]
    },
    {
      "id": "site-hakuto-r-m1",
      "target": "site:hakuto-r-m1",
      "kind": "orbital",
      "file": "https://lroc.im-ldi.com/ckeditor_assets/pictures/1318/content_ispaceImpact_Cover_scale.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://lroc.im-ldi.com/images/1302"]
    },
    {
      "id": "site-luna-25",
      "target": "site:luna-25",
      "kind": "orbital",
      "file": "https://lroc.im-ldi.com/ckeditor_assets/pictures/1346/content_luna25_crater_1100x1100_anot.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://lroc.im-ldi.com/images/1311"]
    },
    {
      "id": "site-ispace-m2-resilience",
      "target": "site:ispace-m2-resilience",
      "kind": "orbital",
      "file": "https://lroc.im-ldi.com/ckeditor_assets/pictures/1564/content_M1504323448LR_mos.str01.CROP_1300.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://lroc.im-ldi.com/images/1456"]
    },
    {
      "id": "site-lcross-centaur",
      "target": "site:lcross-centaur",
      "kind": "similar",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/06/Landsat-9_Centaur_1_%28cropped%29.jpg",
      "credit": "NASA/Randy Beaudoin",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Landsat-9_Centaur_1_(cropped).jpg"]
    },
    {
      "id": "site-lcross-ssc",
      "target": "site:lcross-ssc",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/a/a3/LCROSS_LRO_being_prepared_for_fairing_installation.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:LCROSS_LRO_being_prepared_for_fairing_installation.jpg"
      ]
    },
    {
      "id": "site-grail-a-ebb",
      "target": "site:grail-a-ebb",
      "kind": "illustration",
      "file": "https://images-assets.nasa.gov/image/PIA13956/PIA13956~medium.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://images.nasa.gov/details/PIA13956"]
    },
    {
      "id": "site-grail-b-flow",
      "target": "site:grail-b-flow",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/c6/Illustration_of_GRAIL_spacecraft_over_the_Moon_%28PIA13965%29.jpg",
      "credit": "NASA/JPL-Caltech/MIT",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Illustration_of_GRAIL_spacecraft_over_the_Moon_(PIA13965).jpg"
      ]
    },
    {
      "id": "site-ladee",
      "target": "site:ladee",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/01/LADEE_Impact_Crater_Found%21_%28LROC822_-_content_acd13-0101-011_0%29.jpg",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:LADEE_Impact_Crater_Found!_(LROC822_-_content_acd13-0101-011_0).jpg"
      ]
    },
    {
      "id": "site-smart-1",
      "target": "site:smart-1",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f8/Artist%27s_impression_of_the_SMART-1_mission_ESA199399.jpg",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Artist%27s_impression_of_the_SMART-1_mission_ESA199399.jpg"
      ]
    },
    {
      "id": "site-ranger-6",
      "target": "site:ranger-6",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/95/Granite_Oil_Slip_Table_ranger6_table-600.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Granite_Oil_Slip_Table_ranger6_table-600.jpg"]
    },
    {
      "id": "site-ranger-7",
      "target": "site:ranger-7",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e4/PIA23520_Ranger_7.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:PIA23520_Ranger_7.jpg"]
    },
    {
      "id": "site-ranger-8",
      "target": "site:ranger-8",
      "kind": "similar",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/bd/The_Ranger_Spacecraft_GPN-2000-001979.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:The_Ranger_Spacecraft_GPN-2000-001979.jpg"]
    },
    {
      "id": "site-ranger-9",
      "target": "site:ranger-9",
      "kind": "similar",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/bd/The_Ranger_Spacecraft_GPN-2000-001979.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:The_Ranger_Spacecraft_GPN-2000-001979.jpg"]
    },
    {
      "id": "site-apollo-13-sivb",
      "target": "site:apollo-13-sivb",
      "kind": "similar",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Saturn_IB_Second_Stage_with_open_LM_adapter.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Saturn_IB_Second_Stage_with_open_LM_adapter.jpg"]
    },
    {
      "id": "site-apollo-14-sivb",
      "target": "site:apollo-14-sivb",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/c3/Apollo_14_S-IVB_Impact_Crater_%28LROC60_-_as17-148-22724%29.png",
      "credit": "NASA/GSFC/Arizona State University",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Apollo_14_S-IVB_Impact_Crater_(LROC60_-_as17-148-22724).png"
      ]
    },
    {
      "id": "site-apollo-15-sivb",
      "target": "site:apollo-15-sivb",
      "kind": "similar",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Saturn_IB_Second_Stage_with_open_LM_adapter.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Saturn_IB_Second_Stage_with_open_LM_adapter.jpg"]
    },
    {
      "id": "site-apollo-16-sivb",
      "target": "site:apollo-16-sivb",
      "kind": "similar",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Saturn_IB_Second_Stage_with_open_LM_adapter.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Saturn_IB_Second_Stage_with_open_LM_adapter.jpg"]
    },
    {
      "id": "site-apollo-17-sivb",
      "target": "site:apollo-17-sivb",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/as17-148-22687/as17-148-22687~medium.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://images.nasa.gov/details/as17-148-22687"]
    },
    {
      "id": "site-viking-1",
      "target": "site:viking-1",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/75/Viking_spacecraft.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Viking_spacecraft.jpg"]
    },
    {
      "id": "site-viking-2",
      "target": "site:viking-2",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/b7/KSC-75p-110_%28101-KSC-75P-110%29.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:KSC-75p-110_(101-KSC-75P-110).jpg"]
    },
    {
      "id": "site-mars-pathfinder",
      "target": "site:mars-pathfinder",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/PIA01120/PIA01120~medium.jpg",
      "credit": "NASA/JPL",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://images.nasa.gov/details/PIA01120"]
    },
    {
      "id": "site-spirit-landing",
      "target": "site:spirit-landing",
      "kind": "photo",
      "file": "https://science.nasa.gov/wp-content/uploads/2024/03/sol016-lander-pan-pia05117.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://photojournal.jpl.nasa.gov/catalog/PIA05117"]
    },
    {
      "id": "site-spirit-last",
      "target": "site:spirit-last",
      "kind": "illustration",
      "file": "https://assets.science.nasa.gov/content/dam/science/psd/solar/2023/07/rover2-1.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://science.nasa.gov/mission/mer-spirit/"]
    },
    {
      "id": "site-opportunity-landing",
      "target": "site:opportunity-landing",
      "kind": "photo",
      "file": "https://science.nasa.gov/wp-content/uploads/2024/03/sol058-to-060-lion-king-pia05755.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://photojournal.jpl.nasa.gov/catalog/PIA05755"]
    },
    {
      "id": "site-phoenix",
      "target": "site:phoenix",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/c1/Phoenix_on_the_Red_Planet.jpg",
      "credit": "NASA/JPL/Corby Waste",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Phoenix_on_the_Red_Planet.jpg"]
    },
    {
      "id": "site-curiosity-landing",
      "target": "site:curiosity-landing",
      "kind": "illustration",
      "file": "https://assets.science.nasa.gov/content/dam/science/psd/mars/resources/detail_files/3/3651_PIA14840-full2.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://photojournal.jpl.nasa.gov/catalog/PIA14840"]
    },
    {
      "id": "site-insight",
      "target": "site:insight",
      "kind": "illustration",
      "file": "https://images-assets.nasa.gov/image/PIA22227/PIA22227~medium.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://images.nasa.gov/details/PIA22227"]
    },
    {
      "id": "site-perseverance-landing",
      "target": "site:perseverance-landing",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/6e/Perseverance_sky_crane_%28cropped%29.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Perseverance_sky_crane_(cropped).jpg"]
    },
    {
      "id": "site-tianwen-1-lander",
      "target": "site:tianwen-1-lander",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/2e/Tianwen-1_Lander_and_Zhurong_Rover_in_Southern_Utopia_Planitia.jpg",
      "credit": "NASA/JPL/UArizona",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Tianwen-1_Lander_and_Zhurong_Rover_in_Southern_Utopia_Planitia.jpg"
      ]
    },
    {
      "id": "site-mars-3",
      "target": "site:mars-3",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Mars_3_%28MMA_2011%29_%282%29.JPG",
      "credit": "Armael",
      "licence": "cc0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Mars_3_(MMA_2011)_(2).JPG"]
    },
    {
      "id": "site-beagle-2",
      "target": "site:beagle-2",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/6d/Beagle_2_at_the_Science_Museum.jpg",
      "credit": "gocarts",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Beagle_2_at_the_Science_Museum.jpg"]
    },
    {
      "id": "norad-23802",
      "target": "norad:23802",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/24/Artist%27s_conception_of_NASA_solar_polar_spacecraft.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Artist%27s_conception_of_NASA_solar_polar_spacecraft.jpg"
      ]
    },
    {
      "id": "norad-25560",
      "target": "norad:25560",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1d/Gsfc_swas4.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Gsfc_swas4.jpg"]
    },
    {
      "id": "norad-25989",
      "target": "norad:25989",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/94/Artist_rendering_of_the_XMM-Newton_telescope_against_Earth.jpg",
      "credit": "ESA/XMM-Newton",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Artist_rendering_of_the_XMM-Newton_telescope_against_Earth.jpg"
      ]
    },
    {
      "id": "norad-25994",
      "target": "norad:25994",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/92/Terra_spacecraft_model.png",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Terra_spacecraft_model.png"]
    },
    {
      "id": "norad-26998",
      "target": "norad:26998",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/c4/TIMED.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:TIMED.jpg"]
    },
    {
      "id": "norad-27651",
      "target": "norad:27651",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/c1/SORCE_spacecraft_model.png",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:SORCE_spacecraft_model.png"]
    },
    {
      "id": "norad-27858",
      "target": "norad:27858",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/KSC-03pd2110/KSC-03pd2110~medium.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://images.nasa.gov/details/KSC-03pd2110"]
    },
    {
      "id": "norad-38358",
      "target": "norad:38358",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/ee/NuStar_2.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:NuStar_2.jpg"]
    },
    {
      "id": "norad-39197",
      "target": "norad:39197",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/d1/IRIS_satellite.jpg",
      "credit": "NASA's Goddard Space Flight Center",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:IRIS_satellite.jpg"]
    },
    {
      "id": "norad-49954",
      "target": "norad:49954",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/db/Imaging-X-ray-Polarimetry-Explorer-artist-s-view.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Imaging-X-ray-Polarimetry-Explorer-artist-s-view.jpg"
      ]
    },
    {
      "id": "norad-69123",
      "target": "norad:69123",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Smile_spacecraft_%28artist_impression%29_ESA501293.png",
      "credit": "ESA",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Smile_spacecraft_(artist_impression)_ESA501293.png"
      ]
    },
    {
      "id": "launch-cape-canaveral",
      "target": "launch:cape-canaveral",
      "kind": "aerial",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/00/Aerial_view_of_Kennedy_and_Cape_Canaveral_%28NHQ20260513_admin_0007%29.jpg",
      "credit": "NASA/John Kraus",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Aerial_view_of_Kennedy_and_Cape_Canaveral_(NHQ20260513_admin_0007).jpg"
      ]
    },
    {
      "id": "launch-vandenberg",
      "target": "launch:vandenberg",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/72/2016_Falcon_9_at_Vandenberg_Air_Force_Base.jpg",
      "credit": "SpaceX",
      "licence": "cc0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:2016_Falcon_9_at_Vandenberg_Air_Force_Base.jpg"]
    },
    {
      "id": "launch-wallops",
      "target": "launch:wallops",
      "kind": "aerial",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/2c/Wallops_Island_-_Overview.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Wallops_Island_-_Overview.jpg"]
    },
    {
      "id": "launch-starbase",
      "target": "launch:starbase",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/36/Starship_sidebar_image.jpg",
      "credit": "Alexander Hatley",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Starship_sidebar_image.jpg"]
    },
    {
      "id": "launch-kodiak",
      "target": "launch:kodiak",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/b3/210713_Pacific_Spaceport_Complex_Alaska_%2851311686928%29.jpg",
      "credit": "James Brooks",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:210713_Pacific_Spaceport_Complex_Alaska_(51311686928).jpg"
      ]
    },
    {
      "id": "launch-kourou",
      "target": "launch:kourou",
      "kind": "photo",
      "file": "https://images-assets.nasa.gov/image/NHQ202112250014/NHQ202112250014~medium.jpg",
      "credit": "NASA/Bill Ingalls",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://images.nasa.gov/details/NHQ202112250014"]
    },
    {
      "id": "launch-baikonur",
      "target": "launch:baikonur",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/59/Soyuz_expedition_19_launch_pad.jpg",
      "credit": "NASA/Bill Ingalls",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Soyuz_expedition_19_launch_pad.jpg"]
    },
    {
      "id": "launch-plesetsk",
      "target": "launch:plesetsk",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/07/Plesetsk_Cosmodrome_2015.jpg",
      "credit": "Department of Information of the Ministry of Defense of Russia",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Plesetsk_Cosmodrome_2015.jpg"]
    },
    {
      "id": "launch-kapustin-yar",
      "target": "launch:kapustin-yar",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/01/NASA_FIRMS_2024-10-13_Kapustin_Yar.png",
      "credit": "NASA LANCE FIRMS",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:NASA_FIRMS_2024-10-13_Kapustin_Yar.png"]
    },
    {
      "id": "launch-jiuquan",
      "target": "launch:jiuquan",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1c/Jiuquan_Satellite_Launch_Center_main_launch_tower.JPG",
      "credit": "AAxanderr",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Jiuquan_Satellite_Launch_Center_main_launch_tower.JPG"
      ]
    },
    {
      "id": "launch-taiyuan",
      "target": "launch:taiyuan",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/6e/30MAR2023_Launch_of_Hongtu-1_Satellites.png",
      "credit": "China News Service",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:30MAR2023_Launch_of_Hongtu-1_Satellites.png"]
    },
    {
      "id": "launch-xichang",
      "target": "launch:xichang",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/2f/The_Launch_of_Long_March_3B_Rocket.jpg",
      "credit": "AAxanderr",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:The_Launch_of_Long_March_3B_Rocket.jpg"]
    },
    {
      "id": "launch-wenchang",
      "target": "launch:wenchang",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1f/Long_March_5_rollout_05.png",
      "credit": "China News Service",
      "licence": "cc-by-3.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Long_March_5_rollout_05.png"]
    },
    {
      "id": "launch-tanegashima",
      "target": "launch:tanegashima",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/45/Global_Precipitation_Measurement_%28GPM%29_pre-launch.jpg",
      "credit": "NASA/Bill Ingalls",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Global_Precipitation_Measurement_(GPM)_pre-launch.jpg"
      ]
    },
    {
      "id": "launch-uchinoura",
      "target": "launch:uchinoura",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e1/UchinouraSpaceCenterFromHoshigaoka_retaillee.JPG",
      "credit": "Ippukucho",
      "licence": "cc-by-3.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:UchinouraSpaceCenterFromHoshigaoka_retaillee.JPG"]
    },
    {
      "id": "launch-shahroud",
      "target": "launch:shahroud",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/19/Qaem-100_flight_4.jpg",
      "credit": "Tasnim News Agency",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Qaem-100_flight_4.jpg"]
    },
    {
      "id": "launch-sohae",
      "target": "launch:sohae",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/58/North_Korean_Unha-3_rocket_at_launch_pad.jpg",
      "credit": "Sungwon Baik (VOA)",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:North_Korean_Unha-3_rocket_at_launch_pad.jpg"]
    },
    {
      "id": "launch-mahia",
      "target": "launch:mahia",
      "kind": "aerial",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/01/Rocket_Lab_Launch_Complex_1_survey_image.jpg",
      "credit": "Land Information New Zealand (LINZ)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:Rocket_Lab_Launch_Complex_1_survey_image.jpg"]
    },
    {
      "id": "launch-esrange",
      "target": "launch:esrange",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/44/The_launch_of_the_MAPHEUS-3_sounding_rocket.jpg",
      "credit": "DLR",
      "licence": "cc-by-3.0-de",
      "verified": "2026-10-16",
      "sources": ["https://commons.wikimedia.org/wiki/File:The_launch_of_the_MAPHEUS-3_sounding_rocket.jpg"]
    },
    {
      "id": "launch-alcantara",
      "target": "launch:alcantara",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/68/Visita_ao_Centro_de_Lan%C3%A7amento_em_Alc%C3%A2ntara_%2849974612311%29.jpg",
      "credit": "Ministério da Ciência, Tecnologia e Inovações (Brazil)",
      "licence": "cc-by-2.0",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Visita_ao_Centro_de_Lan%C3%A7amento_em_Alc%C3%A2ntara_(49974612311).jpg"
      ]
    },
    {
      "id": "launch-kwajalein",
      "target": "launch:kwajalein",
      "kind": "aerial",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/17/Ronald_Reagan_Ballistic_Missile_Defense_Test_Site_at_Kwajalein_Atoll%2C_Republic_of_the_Marshall_Islands.jpg",
      "credit": "U.S. Army",
      "licence": "public-domain",
      "verified": "2026-10-16",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Ronald_Reagan_Ballistic_Missile_Defense_Test_Site_at_Kwajalein_Atoll,_Republic_of_the_Marshall_Islands.jpg"
      ]
    },
    {
      "id": "mission-queqiao-1",
      "target": "mission:queqiao-1",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/0b/QueqiaoDFH.jpg",
      "credit": "Zhang Lihua/DFH Satellite Co.",
      "licence": "cc-by-4.0",
      "verified": "2026-10-17",
      "sources": ["https://commons.wikimedia.org/wiki/File:QueqiaoDFH.jpg"]
    },
    {
      "id": "mission-queqiao-2",
      "target": "mission:queqiao-2",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/45/Queqiao_2_relay_satellite_model.png",
      "credit": "China News Service",
      "licence": "cc-by-3.0",
      "verified": "2026-10-17",
      "sources": ["https://commons.wikimedia.org/wiki/File:Queqiao_2_relay_satellite_model.png"]
    },
    {
      "id": "mission-change-7",
      "target": "mission:change-7",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/3c/Artist_view_of_Chang%27e_7_lunar_mission_post_launch_01.png",
      "credit": "China News Service",
      "licence": "cc-by-3.0",
      "verified": "2026-10-17",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Artist_view_of_Chang%27e_7_lunar_mission_post_launch_01.png"
      ]
    },
    {
      "id": "norad-48274",
      "target": "norad:48274",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/25/Chinese_Tiangong_Space_Station.jpg",
      "credit": "Shujianyang",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-19",
      "sources": ["https://commons.wikimedia.org/wiki/File:Chinese_Tiangong_Space_Station.jpg"]
    },
    {
      "id": "site-huygens",
      "target": "site:huygens",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/bc/Huygens_surface_color.jpg",
      "credit": "ESA/NASA/JPL/University of Arizona",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Huygens_surface_color.jpg"]
    },
    {
      "id": "site-venera-7",
      "target": "site:venera-7",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/28/Venera-7.jpg",
      "credit": "Stanislav Kozlovskiy",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Venera-7.jpg"]
    },
    {
      "id": "site-venera-9",
      "target": "site:venera-9",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/ff/Foto_de_Venera_9.png",
      "credit": "USSR Academy of Sciences, processing by Ted Stryk",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Foto_de_Venera_9.png"]
    },
    {
      "id": "site-venera-10",
      "target": "site:venera-10",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Venera10surface.gif",
      "credit": "USSR Academy of Sciences / NASA NSSDC",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Venera10surface.gif"]
    },
    {
      "id": "site-venera-11",
      "target": "site:venera-11",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/9d/Cut-away_model_of_a_Soviet_Venera_12_lander.jpg",
      "credit": "Don S. Montgomery, U.S. Navy (Ret.)",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Cut-away_model_of_a_Soviet_Venera_12_lander.jpg"]
    },
    {
      "id": "site-venera-12",
      "target": "site:venera-12",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/9d/Cut-away_model_of_a_Soviet_Venera_12_lander.jpg",
      "credit": "Don S. Montgomery, U.S. Navy (Ret.)",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Cut-away_model_of_a_Soviet_Venera_12_lander.jpg"]
    },
    {
      "id": "site-venera-13",
      "target": "site:venera-13",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/74/Surface_of_Venus_from_Venera_13.jpg",
      "credit": "Lunar and Planetary Institute, prepared for NASA by Stephen Paul Meszaros",
      "licence": "cc-by-2.0",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Surface_of_Venus_from_Venera_13.jpg"]
    },
    {
      "id": "site-venera-14",
      "target": "site:venera-14",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/21/Venera_14_surface_image.jpg",
      "credit": "Lunar and Planetary Institute, prepared for NASA by Stephen Paul Meszaros",
      "licence": "cc-by-2.0",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Venera_14_surface_image.jpg"]
    },
    {
      "id": "site-vega-1-lander",
      "target": "site:vega-1-lander",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Vega_Spuskaemiy_apparat_vega.jpg",
      "credit": "Emerezhko",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Vega_Spuskaemiy_apparat_vega.jpg"]
    },
    {
      "id": "site-vega-2-lander",
      "target": "site:vega-2-lander",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f9/Vega_Spuskaemiy_apparat_vega.jpg",
      "credit": "Emerezhko",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Vega_Spuskaemiy_apparat_vega.jpg"]
    },
    {
      "id": "site-pioneer-venus-large-probe",
      "target": "site:pioneer-venus-large-probe",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/3a/Pioneer_Venus_Multiprobe_%28ARC-1978-AC78-9245%29.jpg",
      "credit": "NASA/Paul Hudson",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Pioneer_Venus_Multiprobe_(ARC-1978-AC78-9245).jpg"]
    },
    {
      "id": "site-pioneer-venus-north-probe",
      "target": "site:pioneer-venus-north-probe",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/3a/Pioneer_Venus_Multiprobe_%28ARC-1978-AC78-9245%29.jpg",
      "credit": "NASA/Paul Hudson",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Pioneer_Venus_Multiprobe_(ARC-1978-AC78-9245).jpg"]
    },
    {
      "id": "site-pioneer-venus-day-probe",
      "target": "site:pioneer-venus-day-probe",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/3a/Pioneer_Venus_Multiprobe_%28ARC-1978-AC78-9245%29.jpg",
      "credit": "NASA/Paul Hudson",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Pioneer_Venus_Multiprobe_(ARC-1978-AC78-9245).jpg"]
    },
    {
      "id": "site-pioneer-venus-night-probe",
      "target": "site:pioneer-venus-night-probe",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/3a/Pioneer_Venus_Multiprobe_%28ARC-1978-AC78-9245%29.jpg",
      "credit": "NASA/Paul Hudson",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": ["https://commons.wikimedia.org/wiki/File:Pioneer_Venus_Multiprobe_(ARC-1978-AC78-9245).jpg"]
    },
    {
      "id": "site-messenger-impact",
      "target": "site:messenger-impact",
      "kind": "orbital",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/2e/Details_of_MESSENGER%27s_Impact_Location.jpg",
      "credit": "NASA/Johns Hopkins University Applied Physics Laboratory/Carnegie Institution of Washington",
      "licence": "public-domain",
      "verified": "2026-10-23",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Details_of_MESSENGER%27s_Impact_Location.jpg",
        "https://photojournal.jpl.nasa.gov/catalog/PIA19443"
      ]
    },
    {
      "id": "mission-planck",
      "target": "mission:planck",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/11/Model_of_the_Planck_Satellite.jpg",
      "credit": "Mike Peel (www.mikepeel.net)",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-25",
      "sources": ["https://commons.wikimedia.org/wiki/File:Model_of_the_Planck_Satellite.jpg"]
    },
    {
      "id": "mission-herschel",
      "target": "mission:herschel",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/42/Model_of_the_Herschel_space_telescope.jpg",
      "credit": "Mike Peel (www.mikepeel.net)",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-25",
      "sources": ["https://commons.wikimedia.org/wiki/File:Model_of_the_Herschel_space_telescope.jpg"]
    },
    {
      "id": "mission-mariner-2",
      "target": "mission:mariner-2",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/90/Mariner_2.jpg",
      "credit": "NASA/JPL",
      "licence": "public-domain",
      "verified": "2026-10-25",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Mariner_2.jpg",
        "https://photojournal.jpl.nasa.gov/catalog/PIA04594"
      ]
    },
    {
      "id": "mission-mariner-10",
      "target": "mission:mariner-10",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/8/84/Mariner_10_flight_spare.jpg",
      "credit": "Smithsonian Institution",
      "licence": "cc0",
      "verified": "2026-10-25",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Mariner_10_flight_spare.jpg",
        "https://www.si.edu/object/nasm_A19830006000"
      ]
    },
    {
      "id": "mission-helios",
      "target": "mission:helios",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1d/Helios_spacecraft.jpg",
      "credit": "NASA",
      "licence": "public-domain",
      "verified": "2026-10-25",
      "sources": ["https://commons.wikimedia.org/wiki/File:Helios_spacecraft.jpg"]
    },
    {
      "id": "mission-hayabusa",
      "target": "mission:hayabusa",
      "kind": "replica",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/34/Hayabusa_restoration_model_-_National_Museum_of_Nature_and_Science%2C_Tokyo_-_DSC07391.JPG",
      "credit": "Daderot",
      "licence": "cc0",
      "verified": "2026-10-25",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Hayabusa_restoration_model_-_National_Museum_of_Nature_and_Science,_Tokyo_-_DSC07391.JPG"
      ]
    },
    {
      "id": "mission-ulysses",
      "target": "mission:ulysses",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/68/Ulysses_spacecraft.jpg",
      "credit": "NASA/JPL",
      "licence": "public-domain",
      "verified": "2026-10-25",
      "sources": ["https://commons.wikimedia.org/wiki/File:Ulysses_spacecraft.jpg"]
    },
    {
      "id": "mission-akatsuki",
      "target": "mission:akatsuki",
      "kind": "illustration",
      "file": "https://upload.wikimedia.org/wikipedia/commons/d/d7/Akatsuki_CG01.png",
      "credit": "JAXA/ISAS",
      "licence": "cc-by-4.0",
      "verified": "2026-10-25",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Akatsuki_CG01.png",
        "https://isas-gallery.jp/tag/akatsuki"
      ]
    },
    {
      "id": "comet-halley",
      "target": "comet:halley",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/2/2a/Lspn_comet_halley.jpg",
      "credit": "NASA/W. Liller",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": ["https://commons.wikimedia.org/wiki/File:Lspn_comet_halley.jpg"]
    },
    {
      "id": "comet-encke",
      "target": "comet:encke",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/66/Comet_Encke_from_MESSENGER.png",
      "credit": "NASA/JHU APL/Carnegie Institution of Washington",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": ["https://commons.wikimedia.org/wiki/File:Comet_Encke_from_MESSENGER.png"]
    },
    {
      "id": "comet-tempel-1",
      "target": "comet:tempel-1",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/ff/Tempel1_Composite.jpg",
      "credit": "NASA/JPL-Caltech/UMD",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Tempel1_Composite.jpg",
        "https://photojournal.jpl.nasa.gov/catalog/PIA02142"
      ]
    },
    {
      "id": "comet-pons-brooks",
      "target": "comet:pons-brooks",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/6a/Pons-Brooks.png",
      "credit": "Giuseppe Donatiello",
      "licence": "cc0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Pons-Brooks.png",
        "https://www.flickr.com/photos/133259498@N05/53572766715/"
      ]
    },
    {
      "id": "comet-olbers",
      "target": "comet:olbers",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/a/a4/Comet_Olbers_%28by_Jan_Ber%C3%A1nek%29.jpg",
      "credit": "Jan Beránek",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Comet_Olbers_(by_Jan_Ber%C3%A1nek).jpg",
        "https://www.astrobin.com/i378tq/"
      ]
    },
    {
      "id": "comet-schwassmann-wachmann-1",
      "target": "comet:schwassmann-wachmann-1",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/38/The_Heart_of_a_Centaur_-_Iotw2149a.jpg",
      "credit": "International Gemini Observatory/NOIRLab/NSF/AURA/C. Schambeau; image processing: T.A. Rector, M. Zamani & D. de Martin",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:The_Heart_of_a_Centaur_-_Iotw2149a.jpg",
        "https://noirlab.edu/public/images/iotw2149a/"
      ]
    },
    {
      "id": "comet-churyumov-gerasimenko",
      "target": "comet:churyumov-gerasimenko",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/8/81/Comet_67P_on_19_September_2014_NavCam_mosaic.jpg",
      "credit": "ESA/Rosetta/NAVCAM",
      "licence": "cc-by-sa-3.0-igo",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Comet_67P_on_19_September_2014_NavCam_mosaic.jpg",
        "https://www.esa.int/ESA_Multimedia/Images/2014/09/Comet_on_19_September_2014_NavCam"
      ]
    },
    {
      "id": "comet-hartley-2",
      "target": "comet:hartley-2",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/e6/Comet_Hartley_2.jpg",
      "credit": "NASA/JPL-Caltech/UMD",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": ["https://commons.wikimedia.org/wiki/File:Comet_Hartley_2.jpg"]
    },
    {
      "id": "comet-hale-bopp",
      "target": "comet:hale-bopp",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1f/Comet_Hale-Bopp_Phot-mar14-hbs-2.jpg",
      "credit": "ESO/E. Slawik",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Comet_Hale-Bopp_Phot-mar14-hbs-2.jpg",
        "https://www.eso.org/public/images/phot-mar14-hbs-2/"
      ]
    },
    {
      "id": "comet-tsuchinshan-atlas",
      "target": "comet:tsuchinshan-atlas",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/8/87/Comet_C_2023_A3_Tsuchinshan_ATLAS_tail_and_antitail.jpg",
      "credit": "FoxBill",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Comet_C_2023_A3_Tsuchinshan_ATLAS_tail_and_antitail.jpg"
      ]
    },
    {
      "id": "comet-tempel-2",
      "target": "comet:tempel-2",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/67/10P_Tempel_-_55466409444.png",
      "credit": "PJ Singh (paramsach)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:10P_Tempel_-_55466409444.png",
        "https://www.flickr.com/photos/paramsach/55466409444/"
      ]
    },
    {
      "id": "comet-howell",
      "target": "comet:howell",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f2/88P-20260614-1101.png",
      "credit": "Kevin Heider (Kheider)",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-26",
      "sources": ["https://commons.wikimedia.org/wiki/File:88P-20260614-1101.png"]
    },
    {
      "id": "comet-hartley-iras",
      "target": "comet:hartley-iras",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/35/Comet_161P_Hartley%E2%80%93IRAS_astrophotography_by_Denis_Melamed_2026.jpg",
      "credit": "Denis Melamed",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Comet_161P_Hartley%E2%80%93IRAS_astrophotography_by_Denis_Melamed_2026.jpg"
      ]
    },
    {
      "id": "comet-mcnaught-220p",
      "target": "comet:mcnaught-220p",
      "kind": "photo",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1e/Comet_220P.png",
      "credit": "Chuck Ayoub",
      "licence": "cc0",
      "verified": "2026-10-26",
      "sources": ["https://commons.wikimedia.org/wiki/File:Comet_220P.png"]
    },
    {
      "id": "comet-bernardinelli-bernstein",
      "target": "comet:bernardinelli-bernstein",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/6f/C-2014UN271-BB_Hubble_2022Mar28_unannotated.png",
      "credit": "Nrco0e, from NASA/ESA Hubble Space Telescope data",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:C-2014UN271-BB_Hubble_2022Mar28_unannotated.png",
        "https://archive.stsci.edu/proposal_search.php?id=16878&mission=hst"
      ]
    },
    {
      "id": "asteroid-2-pallas",
      "target": "asteroid:2-pallas",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f1/2_Pallas_-_ESO_-_Potw2008a.tif",
      "credit": "ESO/M. Marsset, P. Vernazza et al./MISTRAL algorithm (ONERA/CNRS)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:2_Pallas_-_ESO_-_Potw2008a.tif",
        "https://www.eso.org/public/images/potw2008a/"
      ]
    },
    {
      "id": "asteroid-10-hygiea",
      "target": "asteroid:10-hygiea",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/8/88/SPHERE_image_of_Hygiea.jpg",
      "credit": "ESO/P. Vernazza et al./MISTRAL algorithm (ONERA/CNRS)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:SPHERE_image_of_Hygiea.jpg",
        "https://www.eso.org/public/images/eso1918a/"
      ]
    },
    {
      "id": "asteroid-704-interamnia",
      "target": "asteroid:704-interamnia",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/b/be/%28704%29_Interamnia_VLTSPHERE.png",
      "credit": "P. Vernazza et al. 2021 (A&A 654, A56), ESO VLT/SPHERE",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:(704)_Interamnia_VLTSPHERE.png",
        "https://doi.org/10.1051/0004-6361/202141781"
      ]
    },
    {
      "id": "asteroid-52-europa",
      "target": "asteroid:52-europa",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/ed/%2852%29_Europa_VLTSPHERE.png",
      "credit": "P. Vernazza et al. 2021 (A&A 654, A56), ESO VLT/SPHERE",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:(52)_Europa_VLTSPHERE.png",
        "https://doi.org/10.1051/0004-6361/202141781"
      ]
    },
    {
      "id": "asteroid-511-davida",
      "target": "asteroid:511-davida",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/4c/%28511%29_Davida_VLTSPHERE.png",
      "credit": "P. Vernazza et al. 2021 (A&A 654, A56), ESO VLT/SPHERE",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:(511)_Davida_VLTSPHERE.png",
        "https://doi.org/10.1051/0004-6361/202141781"
      ]
    },
    {
      "id": "asteroid-87-sylvia",
      "target": "asteroid:87-sylvia",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/07/Sylvia_VLT.png",
      "credit": "ESO/Vernazza et al./MISTRAL algorithm (ONERA/CNRS)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Sylvia_VLT.png",
        "https://www.eso.org/public/images/eso2114d/"
      ]
    },
    {
      "id": "asteroid-15-eunomia",
      "target": "asteroid:15-eunomia",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/42/%2815%29_Eunomia_VLTSPHERE.png",
      "credit": "P. Vernazza et al. 2021 (A&A 654, A56), ESO VLT/SPHERE",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:(15)_Eunomia_VLTSPHERE.png",
        "https://doi.org/10.1051/0004-6361/202141781"
      ]
    },
    {
      "id": "asteroid-65-cybele",
      "target": "asteroid:65-cybele",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/9d/Cybele_ZIMPOL.png",
      "credit": "M. Marsset et al. 2023 (A&A 670, A52), ESO VLT/SPHERE-ZIMPOL",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Cybele_ZIMPOL.png",
        "https://www.aanda.org/articles/aa/full_html/2023/02/aa43859-22/F1.html"
      ]
    },
    {
      "id": "asteroid-3-juno",
      "target": "asteroid:3-juno",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/61/3_Juno_VLT_%282021%29.png",
      "credit": "P. Vernazza et al. 2021 (A&A 654, A56), ESO VLT/SPHERE",
      "licence": "cc-by-sa-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:3_Juno_VLT_(2021).png",
        "https://doi.org/10.1051/0004-6361/202141781"
      ]
    },
    {
      "id": "asteroid-21-lutetia",
      "target": "asteroid:21-lutetia",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/31/%2821%29_Lutetia_VLTSPHERE.png",
      "credit": "P. Vernazza et al. 2021 (A&A 654, A56), ESO VLT/SPHERE",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:(21)_Lutetia_VLTSPHERE.png",
        "https://doi.org/10.1051/0004-6361/202141781"
      ]
    },
    {
      "id": "asteroid-243-ida",
      "target": "asteroid:243-ida",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/3/32/Ida_and_Dactyl_by_Galileo_%28P-44131%29.jpg",
      "credit": "NASA/JPL",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Ida_and_Dactyl_by_Galileo_(P-44131).jpg",
        "https://nssdc.gsfc.nasa.gov/imgcat/html/object_page/gal_p44131.html"
      ]
    },
    {
      "id": "asteroid-253-mathilde",
      "target": "asteroid:253-mathilde",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/e/ed/253_Mathilde_HQ.png",
      "credit": "NASA/JHU APL (NEAR)",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:253_Mathilde_HQ.png",
        "https://science.nasa.gov/photojournal/two-very-different-asteroids/"
      ]
    },
    {
      "id": "asteroid-951-gaspra",
      "target": "asteroid:951-gaspra",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/9/9a/Galileo_Gaspra_Mosaic.jpg",
      "credit": "NASA/JPL",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Galileo_Gaspra_Mosaic.jpg",
        "https://photojournal.jpl.nasa.gov/catalog/PIA00119"
      ]
    },
    {
      "id": "asteroid-4179-toutatis",
      "target": "asteroid:4179-toutatis",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/06/Asteroid_4179_Toutatis_close-up.jpg",
      "credit": "CNSA Chang'e 2; Y. Jiang, J. Ji et al. 2015 (Scientific Reports 5, 16029)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Asteroid_4179_Toutatis_close-up.jpg",
        "https://doi.org/10.1038/srep16029"
      ]
    },
    {
      "id": "asteroid-5535-annefrank",
      "target": "asteroid:5535-annefrank",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/1c/Stardust_-_Annefrank.jpg",
      "credit": "NASA/JPL-Caltech",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Stardust_-_Annefrank.jpg",
        "https://stardust.jpl.nasa.gov/"
      ]
    },
    {
      "id": "asteroid-9969-braille",
      "target": "asteroid:9969-braille",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/c3/PIA01345.jpg",
      "credit": "NASA/JPL-Caltech/UMD",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:PIA01345.jpg",
        "https://photojournal.jpl.nasa.gov/catalog/PIA01345"
      ]
    },
    {
      "id": "asteroid-162173-ryugu",
      "target": "asteroid:162173-ryugu",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/5/5b/162173_Ryugu.png",
      "credit": "JAXA/ISAS Hayabusa2 ONC team (DARTS archive), processed by Anonymsiy",
      "licence": "cc-by-4.0",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:162173_Ryugu.png",
        "https://data.darts.isas.jaxa.jp/pub/pds4/data/hyb2/hyb2_onc/data_calibrated/proximity/20180911/",
        "https://www.isas.jaxa.jp/en/researchers/data-policy/"
      ]
    },
    {
      "id": "asteroid-65803-didymos",
      "target": "asteroid:65803-didymos",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/4/4e/Didymos_-_North_Up.png",
      "credit": "NASA/Johns Hopkins APL",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Didymos_-_North_Up.png",
        "https://dart.jhuapl.edu/Gallery/"
      ]
    },
    {
      "id": "asteroid-152830-dinkinesh",
      "target": "asteroid:152830-dinkinesh",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/7/77/Dinkinesh_First_Look_L%27LORRI.png",
      "credit": "NASA/Goddard/SwRI/Johns Hopkins APL/NOIRLab",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Dinkinesh_First_Look_L%27LORRI.png",
        "https://www.nasa.gov/image-article/nasas-lucy-spacecraft-discovers-2nd-asteroid-during-dinkinesh-flyby/"
      ]
    },
    {
      "id": "asteroid-52246-donaldjohanson",
      "target": "asteroid:52246-donaldjohanson",
      "kind": "observation",
      "file": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Donaldjohanson_closest_approach.png",
      "credit": "NASA/Goddard/SwRI/Johns Hopkins APL/NOIRLab",
      "licence": "public-domain",
      "verified": "2026-10-26",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Donaldjohanson_closest_approach.png",
        "https://science.nasa.gov/image-article/nasas-lucy-spacecraft-images-asteroid-donaldjohanson/"
      ]
    },
    {
      "id": "mission-gonggong",
      "target": "mission:gonggong",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/1/17/225088_Gonggong_and_Xiangliu_by_Hubble_%282010%29.png",
      "credit": "NASA, STScI, W. Fraser, G. Marton et al. (Hubble)",
      "licence": "public-domain",
      "verified": "2026-10-28",
      "sources": ["https://commons.wikimedia.org/wiki/File:225088_Gonggong_and_Xiangliu_by_Hubble_(2010).png"]
    },
    {
      "id": "mission-quaoar",
      "target": "mission:quaoar",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/65/Quaoar-Weywot_Hubble_2025-06-30_crop.png",
      "credit": "E. Fernandez-Valenzuela (Hubble, STScI/NASA), processed by Nrco0e",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": ["https://commons.wikimedia.org/wiki/File:Quaoar-Weywot_Hubble_2025-06-30_crop.png"]
    },
    {
      "id": "mission-orcus",
      "target": "mission:orcus",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/6/6f/Orcus-Vanth_discovery.jpg",
      "credit": "NASA/ESA Hubble, M. E. Brown; processed by Nrco0e",
      "licence": "public-domain",
      "verified": "2026-10-28",
      "sources": ["https://commons.wikimedia.org/wiki/File:Orcus-Vanth_discovery.jpg"]
    },
    {
      "id": "mission-sedna",
      "target": "mission:sedna",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/0/02/Sedna_PRC2004-14d.jpg",
      "credit": "NASA, ESA, M. Brown (Hubble)",
      "licence": "public-domain",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Sedna_PRC2004-14d.jpg",
        "https://hubblesite.org/newscenter/newsdesk/archive/releases/2004/14/image/d"
      ]
    },
    {
      "id": "mission-2026-ed138",
      "target": "mission:2026-ed138",
      "kind": "telescope",
      "file": "https://upload.wikimedia.org/wikipedia/commons/f/f6/Mosaic_of_2026_ED138_discovery_images_%28noirlab2626f%29.jpg",
      "credit": "NSF–DOE Vera C. Rubin Observatory/NOIRLab/SLAC/AURA; processing M. Jurić (UW), D. de Martin & M. Zamani (NSF NOIRLab)",
      "licence": "cc-by-4.0",
      "verified": "2026-10-28",
      "sources": [
        "https://commons.wikimedia.org/wiki/File:Mosaic_of_2026_ED138_discovery_images_(noirlab2626f).jpg",
        "https://noirlab.edu/public/images/noirlab2626f/",
        "https://www.washington.edu/news/2026/10/27/rubin-observatory-new-dwarf-planet-candidate/"
      ]
    }
  ]
}
